import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import SocialLinks from './SocialLinks';
import { SITE } from '../../config/site';

const Footer = () => (
    <footer className="relative py-12 px-6 border-t border-white/30 dark:border-white/[0.06]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-4 text-slate-500 dark:text-slate-500 text-sm">
                <span>
                    © {SITE.startYear}–{new Date().getFullYear()} {SITE.name} · React + Firebase
                </span>
                <span className="text-slate-300 dark:text-slate-700">|</span>
                <Link
                    to="/admin"
                    className="flex items-center gap-1.5 hover:text-slate-900 dark:hover:text-white transition-colors"
                >
                    <Lock className="w-3.5 h-3.5" />
                    Quản trị
                </Link>
            </div>
            <SocialLinks />
        </div>
    </footer>
);

export default Footer;
